import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { resetCitizenPassword } from "../Services/getServices";
import { loader } from "../redux/type";
import { toast } from "react-toastify";

const UpdatePassword = () => {
  const navigate = useNavigate();

  const userData=JSON.parse(localStorage.getItem("user"));
  const userId=userData?.user?.userId;
  const dispatch = useDispatch();
  const [userName, setUserName] = useState("");
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confNewPass, setConfNewPass] = useState("");

  function changePass() {
    dispatch({ type: loader.startLoader });
    let req = {
      userName: userId,
      oldPassword: oldPass,
      password: newPass,
      confirmPassword: confNewPass,
    };

    resetCitizenPassword(req, (res) => {
      dispatch({ type: loader.stopLoader });

      if (res?.data?.status) {
toast.success(res?.data?.message)
      } else {
        toast.error(res?.data?.message)
      }
    });
  }

  return (
    <>
      <div className="card shadow myprofileCard mt-2 ">
        <div className="card-body">
          <div
            className="card-title bg-primary "
            style={{ textAlign: "center", height: "3rem", color: "white" }}
          >
            <h5>Update Password </h5>
          </div>
          <div className="row">
            <div className="form-outline col-6 mb-3">
              <label className="form-label" for="id">
                User Id:
              </label>
              <input
                type="mobile"
                id="aadhaarcard"
                value={userId}
                onChange={(e) => setUserName(e.target.value)}
                className="form-control"
                placeholder="Enter here"
                disabled
              />
            </div>

            <div className="form-outline col-6 mb-3">
              <label className="form-label" for="id">
                Old Password:
              </label>
              <input
                type="mobile"
                id="aadhaarcard"
                onChange={(e) => setOldPass(e.target.value)}
                className="form-control"
                placeholder="Enter here"
              />
            </div>

            <div className="form-outline col-6 mb-3">
              <label className="form-label" for="id">
                New Password:
              </label>
              <input
                type="mobile"
                id="aadhaarcard"
                onChange={(e) => setNewPass(e.target.value)}
                className="form-control"
                placeholder="Enter here"
              />
            </div>
            <div className="form-outline col-6 mb-3">
              <label className="form-label" for="id">
                Confirm New Password:
              </label>
              <input
                type="mobile"
                id="aadhaarcard"
                onChange={(e) => setConfNewPass(e.target.value)}
                className="form-control"
                placeholder="Enter here"
              />
            </div>
            <div className="col-3 ">
            <button className="btn btn-primary " onClick={changePass}>
              Change Password
            </button>
            </div>
          </div>
        </div>
      </div>
      {/* <h5>Update passwpord </h5> */}

      {/* <div className="form-outline mb-3">
        <label className="form-label" for="id">
          User Name:
        </label>
        <input
          type="mobile"
          id="aadhaarcard"
          onChange={(e) => setUserName(e.target.value)}
          className="form-control"
          placeholder="Enter here"
        />
      </div>

      <div className="form-outline mb-3">
        <label className="form-label" for="id">
          Old Password:
        </label>
        <input
          type="mobile"
          id="aadhaarcard"
          onChange={(e) => setOldPass(e.target.value)}
          className="form-control"
          placeholder="Enter here"
        />
      </div>

      <div className="form-outline mb-3">
        <label className="form-label" for="id">
          New Password:
        </label>
        <input
          type="mobile"
          id="aadhaarcard"
          onChange={(e) => setNewPass(e.target.value)}
          className="form-control"
          placeholder="Enter here"
        />
      </div>
      <div className="form-outline mb-3">
        <label className="form-label" for="id">
          Confirm New Password:
        </label>
        <input
          type="mobile"
          id="aadhaarcard"
          onChange={(e) => setConfNewPass(e.target.value)}
          className="form-control"
          placeholder="Enter here"
        />
      </div>
      <button className="btn btn-primary" onClick={changePass}>Change Password</button> */}
    </>
  );
};

export default UpdatePassword;
